export type UserDomainStatus = 'waiting_dns' | 'online' | 'error';

export interface IUserDomainBlockCheckResult {
	reachable: boolean;
	httpStatus?: number | null;
	error?: string | null;
}

export interface IUserDomain {
	id: number;
	profileId: number;
	hostname: string;
	zoneName: string;
	dnsRecordName: string;
	cfZoneId: string | null;
	status: UserDomainStatus;
	errorMessage: string | null;
	nsRecords: string[] | null;
	lastCheckAt: string | null;
	lastBlockCheckAt?: string | null;
	blockCheckResult?: IUserDomainBlockCheckResult | null;
	createdAt: string;
	buildsCount?: number;
	launchCount: number;
}

export const DOMAIN_STATUS_LABELS: Record<UserDomainStatus, string> = {
	waiting_dns: 'Ожидание DNS',
	online: 'Онлайн',
	error: 'Ошибка',
};

export function getDomainStatusLabel(status: UserDomainStatus): string {
	return DOMAIN_STATUS_LABELS[status];
}
